/**
 * Web stub: the browser build has no native Google Sign-In SDK and already uses
 * the full-page web-redirect OAuth flow, so this is a no-op that always reports
 * "unavailable". Metro resolves this `.web` file on web, so the native module is
 * never bundled for the browser. Mirrors the exports of `./googleNative`.
 */
export type NativeGoogleResult = { idToken: string } | 'cancelled' | 'unavailable';

export function isNativeGoogleConfigured(): boolean {
  return false;
}

export async function signInWithGoogleNative(): Promise<NativeGoogleResult> {
  return 'unavailable';
}
